import { Theme } from '@fluentui/react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const contextualFormStyles = (theme: Theme) => ({
  containerRoot: {
    borderRadius: theme.effects.roundedCorner6,
    backgroundColor: theme.palette.neutralPrimary,
    boxShadow: theme.effects.elevation8,
  },
  headingContainerRoot: {
    borderBottom: `1px solid ${theme.palette.themeLight}`,
  },
  heading: {
    margin: '10px',
    color: theme.palette.white,
    textAlign: 'center',
  },
  ul: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    textAlign: 'left',
    cursor: 'pointer',
    li: {
      padding: '8px 12px',
      borderBottom: `1px solid ${theme.palette.neutralTertiary}`,
      color: theme.palette.white,
    },
    'li:last-child': {
      borderBottom: 'none',
    },
  },
  inputField: {
    border: 'none',
    color: theme.palette.white,
    ':focus': {
      outline: 'none',
      color: theme.palette.white,
    },
    height: 'auto',
    fontSize: theme.fonts.medium.fontSize,
    fontFamily: 'inherit',
    '::placeholder': {
      color: '#777',
    },
  },
  button: {
    marginTop: '1rem',
    border: 'none',
    borderRadius: theme.effects.roundedCorner6,
    height: '42px',
    boxShadow: theme.effects.elevation8,
    color: 'black',
  },
});
